import React from 'react'
import { useTranslation } from 'react-i18next'
import leoLogo from '@assets/images/partners/leo_logo_px8_100x100.png'
import { DefiDatagotchiCallout } from '@components/DefiDatagotchiCallout/DefiDatagotchiCallout'
import './LeoPanelCallout.scss'

type Props = {
  className?: string
}

/** Results partner CTA — same shell as Défi Datagotchi, LEO branding + flush action. */
export function LeoPanelCallout({ className }: Props) {
  const { t } = useTranslation('Result')
  const url = t('partnerLeo.url', { defaultValue: '' })
  const body = t('partnerLeo.body', { defaultValue: '' })
  const cta = t('partnerLeo.cta', { defaultValue: '' })
  const title = t('partnerLeo.title', { defaultValue: 'PANEL LEO' })

  if (!url || !body) {
    return null
  }

  return (
    <DefiDatagotchiCallout
      className={['LeoPanelCallout', 'DefiDatagotchiCallout--flushAction', className]
        .filter(Boolean)
        .join(' ')}
      icon={leoLogo}
      title={title}>
      <p>{body}</p>
      <a
        className="DefiDatagotchiCallout-action"
        href={url}
        target="_blank"
        rel="noopener noreferrer">
        {cta}
      </a>
    </DefiDatagotchiCallout>
  )
}

export default LeoPanelCallout
